import { Component, ViewChild, ElementRef, OnInit, HostListener, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../../../_service/message-service';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { StationService } from 'src/app/_services/station.service';
import { Renderer2 } from '@angular/core';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { fromEvent } from 'rxjs';
import { AuthenticationService } from 'src/app/_services';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'telio-device-logs',
  templateUrl: './device-logs.component.html',
  styleUrls: ['./device-logs.component.scss']
})
export class DeviceLogsComponent implements OnInit {

  @ViewChild("scrollframe", { static: true }) private scrollframe: ElementRef;

  storeScrollPosition: any;
  currentscrollPosition: any;
  data: any;
  tempData: any;
  filter = true;
  actionReload = true;
  actionDownloadLogs = true;
  isMobileDevice = false;
  form = new UntypedFormGroup({
    searchFilter: new UntypedFormControl(''),
  })
  startDate: Date;
  endDate: Date;
  downloadJsonHref: any;
  timePlaceholder = '';
  currentDate = new Date();
  year = this.currentDate.getFullYear();
  month = (this.currentDate.getMonth()).toString().padStart(2, '0');
  day = this.currentDate.getDate().toString().padStart(2, '0');
  hours = this.currentDate.getHours().toString().padStart(2, '0')
  mins = this.currentDate.getMinutes().toString().padStart(2, '0')
  showDropdown = false;
  selectedOptions = {excel: false,txt: false};
  isDownloadDisabled = true;


  getMaxDate(): any {
    return moment([this.year, parseInt(this.month), parseInt(this.day), parseInt(this.hours), parseInt(this.mins)]);
  }
  getMinDate(): any {
    return moment([this.year, parseInt(this.month), parseInt(this.day)]).subtract(44, 'days');
  }
  @Input() routeID = null;
  @Input() stationId: any;

  constructor(private renderer: Renderer2,
    readonly exportCSVService: ExportCSVService,
    readonly stationService: StationService,
    readonly translate: TranslateService,
    readonly toasterService: SnackbarService,
    readonly router: Router,
    private authenticationService: AuthenticationService,
    private userInfoService: UserInfoService,
    private sanitizer: DomSanitizer) {
    this.timePlaceholder = this.translate.instant('stationDetail.deviceLogs.time');
    this.checkMobileDevice();
  }

  ngOnInit(): void {
    this.getDeviceLogs();
    fromEvent(this.scrollframe.nativeElement, 'scroll')
      .subscribe((e: Event) => {
        if (e.target['scrollTop'] != 0) {
          this.storeScrollPosition = e.target['scrollTop']
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkMobileDevice();
  }

  getScrollBottom() {
    if (!!this.storeScrollPosition) {
      this.scrollframe.nativeElement.scrollTop = this.scrollframe.nativeElement.scrollHeight;
    } else {
      this.scrollframe.nativeElement.scrollTop = 0;
    }
  }

  getDeviceLogs(from?: any, to?: any) {
    this.data = [];
    this.tempData = [];
    this.stationService.getDeviceLogs(this.stationId, from, to).subscribe(
      (data: any) => {
        if (!!data && data.length > 1) {
          this.data = data;
          this.tempData = data;
          let from = this.data[0].timestamp;
          let to = this.data[this.data.length - 1].timestamp;
          this.getInitialPlaceHolder(from, to)
          // this.actionLogsDownload();
          this.scrollframe.nativeElement.scrollTop = this.storeScrollPosition;
        } else {
          this.toasterService.info(this.translate.instant('stationDetail.deviceLogs.noLogExists'));
        }
      }, err => {
        this.actionDownloadLogs = false;
        this.toasterService.error(this.translate.instant('responseFailed'));
      });
  }

  actionClick() {
    this.storeScrollPosition = this.scrollframe.nativeElement.scrollTop;
      if(!!this.startDate && !!this.endDate){
        let stDate = this.dateConversion(this.startDate);
        let endDate = this.dateConversion(this.endDate);
        this.getDeviceLogs(stDate,endDate)
      } else {
        this.getDeviceLogs();
      }
  }

  /**
   * Handler to download logs for the device
   */
  // actionLogsDownload() {
  //   let theJSON = JSON.stringify(this.tempData);
  //   let uri = this.sanitizer.bypassSecurityTrustUrl("data:text/json;charset=UTF-8," + encodeURIComponent(theJSON));
  //   this.downloadJsonHref = uri;
  // }

//   actionLogsDownload() {
//     const filteredData = this.tempData.map(({ error, ...rest }) => rest);

//     const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);

//     const workbook: XLSX.WorkBook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Logs');

//     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//     const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = 'logs.xlsx';
//     link.click();
//     URL.revokeObjectURL(url);
// }

  change(event) {
    if (!!event.startDate && !!event.endDate) {
      this.startDate = new Date(event.startDate.$d);
      this.endDate = new Date(event.endDate.$d);
      let stDate = this.dateConversion(this.startDate);
      let endDate = this.dateConversion(this.endDate);
      this.getDeviceLogs(stDate, endDate);
    }
  }

  dateConversion(date) {
    return this.authenticationService.convertToLocalTimeForPayload(date,this.userInfoService.userDetails.prefCountry)
  }

  getPlaceholder(): string {
    const startDateFormatted = moment(this.startDate).format('MMM D, YYYY h:mm A');
    const endDateFormatted = moment(this.endDate).format('MMM D, YYYY h:mm A');
    return this.timePlaceholder = `${startDateFormatted} - ${endDateFormatted}`;
  }

  getInitialPlaceHolder(from, to): string {
    const startDateFormatted = moment(from).format('MMM D, YYYY h:mm A');
    const endDateFormatted = moment(to).format('MMM D, YYYY h:mm A');
    return this.timePlaceholder = `${startDateFormatted} - ${endDateFormatted}`;
  }

  getCustomCss(origin: string, error: boolean) {
    if (!error) {
      switch (origin) {
        case 'CSMS':
          return 'csms_style';
        case 'DEVICE':
          return 'device_style';
      }
    } else {
      return 'error_style';
    }
  }

  checkMobileDevice() {
    this.isMobileDevice = window.innerWidth <= 767;
  }

  getFilterLogs(type: number) {
    switch (type) {
      case 0:
        return this.data = this.tempData.filter(res => res.origin == 'DEVICE');
      case 1:
        return this.data = this.tempData.filter(res => res.origin == 'CSMS');
      case 2:
        return this.data = this.tempData.filter(res => res.error);
    }
  }

  actionLogsDownload(type: string) {
    const filteredData = this.tempData.map(({ error, ...rest }) => rest);
  
    if (type === 'excel') {
      this.downloadExcel(filteredData);
    }
    if (type === 'txt') {
      this.downloadTxt(filteredData);
    }
  }

  resetSelections() {
    this.selectedOptions = { excel: false, txt: false };
    this.updateButtonState();
  }
  
  downloadExcel(filteredData: any[]) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Logs');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveFile(new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'logs.xlsx');
  }
  
  downloadTxt(filteredData: any[]) {
    const txtContent = filteredData.map(row => JSON.stringify(row)).join('\n');
    const blob = new Blob([txtContent], { type: 'text/plain' });
    this.saveFile(blob, 'logs.txt');
  }
  
  saveFile(blob: Blob, fileName: string) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.showDropdown = !this.showDropdown;
    if (this.showDropdown) {
      this.resetSelections();
    }
  }

  downloadSelectedFiles(event: Event) {
    event.stopPropagation();
    if (this.selectedOptions.excel) {
      this.actionLogsDownload('excel');
    }
    if (this.selectedOptions.txt) {
      this.actionLogsDownload('txt');
    }
    this.resetSelections();
    this.showDropdown = false;
    this.updateButtonState();
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const isInside = clickedElement.closest('.download-dropdown, [mat-icon-button]');

    if (!isInside) {
      this.showDropdown = false;
      this.resetSelections(); 
      this.resetSelections();
    }
  }

  updateButtonState(): void {
    this.isDownloadDisabled = !this.selectedOptions.excel && !this.selectedOptions.txt;
  }
}

